import workorder from "./workorder.json";
import client from "./client.json";
import diagSecu from "./diagSecu.json";
// ca otherwise has no planification bundle (see the other 21 namespaces missing from this
// locale); this one file exists solely to carry the suspension-reason labels for task 12 so
// Catalan planners see real wording here instead of falling back to English, like the rest of
// this scaffolded locale still does.
import planification from "./planification.json";
import machine from "./machine.json";

const lang = {
  workorder,
  client,
  diagSecu,
  planification,
  machine,
};

export default lang;
